import { EntityType } from './entity.types';

/**
 * The entity-type code in the last segment of a CIPC registration number
 * (YYYY/NNNNNN/TT). Mirrors `suggest_type_from_reg_no` in
 * `backend/flow_ai/entities/utils.py`; the backend serves its own on the Ops
 * verification read, so this copy is only for *Add a client*, before the
 * business exists.
 */
const TYPE_BY_REG_NO_SUFFIX: Readonly<Record<string, EntityType>> = {
  '07': 'PTY',
  '08': 'NPO',
  '21': 'INC',
  '23': 'CC',
};

/**
 * The legal form a registration number's suffix suggests, or `null`.
 * ⚠️ A hint, never a value (FLOW-342): nothing selects it on the user's behalf.
 */
export function suggestTypeFromRegNo(regNo: string | null | undefined): EntityType | null {
  const parts = (regNo ?? '').replace(/[^0-9/]/g, '').split('/');
  if (parts.length < 2) return null;
  return TYPE_BY_REG_NO_SUFFIX[parts[parts.length - 1]] ?? null;
}
